/*
  配送ランク ⓘ 吹き出し（StoreHero 2026-09）
  - 商品ページの「配送ランク ◯」ラベルの中へ ⓘ（Impulse 標準の tool-tip-trigger）を移す
  - 吹き出し（Impulse 標準の tool-tip）の中で都道府県を選ぶと、その地域の送料を1件表示する
  - 「配送料金をチェック」欄の中（data-sr-inline）でも同じ表示を行い、選んだ都道府県を吹き出しと共有する
  データはカスタム Liquid ブロックが出力する [data-sr-data]（メタオブジェクト shipping_region 由来）。
*/
(function () {
  'use strict';

  var STORAGE_KEY = 'srTipPref';

  function placeTriggers(root) {
    var scope = root || document;
    var tips = scope.querySelectorAll('[data-sr-tip]');
    Array.prototype.forEach.call(tips, function (tip) {
      var trigger = tip.querySelector('.sr-tip__trigger');
      if (!trigger) return;
      var label = tip.getAttribute('data-sr-label');
      var meta = tip.closest('.product-single__meta');
      if (!meta || !label) return;
      var items = meta.querySelectorAll('.product-tags li[data-tag]');
      for (var i = 0; i < items.length; i++) {
        if (items[i].getAttribute('data-tag') === label) {
          items[i].classList.add('sr-tip-host');
          items[i].appendChild(trigger);
          tip.classList.add('is-placed');
          break;
        }
      }
    });
  }

  function readData(pop) {
    var el = pop.querySelector('[data-sr-data]');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent) || [];
    } catch (e) {
      return [];
    }
  }

  function render(pop, pref) {
    var out = pop.querySelector('[data-sr-result]');
    if (!out) return;
    if (!pref) {
      out.classList.remove('is-filled');
      out.textContent = '都道府県を選ぶと、この商品の送料が表示されます。';
      return;
    }
    var regions = readData(pop);
    var hit = null;
    for (var i = 0; i < regions.length; i++) {
      if (regions[i].p && regions[i].p.indexOf(pref) !== -1) {
        hit = regions[i];
        break;
      }
    }
    out.textContent = '';
    out.classList.add('is-filled');
    var where = document.createElement('span');
    where.className = 'sr-pop__where';
    var amount = document.createElement('b');
    amount.className = 'sr-pop__amount';
    if (!hit) {
      where.textContent = pref + 'へのお届け';
      amount.textContent = '送料は配送料金表をご確認ください';
      amount.classList.add('is-ask');
    } else if (hit.f === null || hit.f === undefined || hit.f === '') {
      where.textContent = pref + '（' + hit.n + '）へのお届け';
      amount.textContent = '個別にご相談ください';
      amount.classList.add('is-ask');
    } else {
      where.textContent = pref + '（' + hit.n + '）へのお届け';
      amount.textContent = hit.f + '（税込）';
    }
    out.appendChild(where);
    out.appendChild(amount);
  }

  function savedPref() {
    try {
      return window.localStorage.getItem(STORAGE_KEY) || '';
    } catch (e) {
      return '';
    }
  }

  function savePref(pref) {
    try {
      window.localStorage.setItem(STORAGE_KEY, pref);
    } catch (e) {}
  }

  // 一度選んだ都道府県があればそれを使い、無ければ「選択してください」のまま
  function applySaved(pop) {
    var pref = savedPref();
    var select = pop.querySelector('[data-sr-pref]');
    if (select && pref) {
      select.value = pref;
      if (select.value !== pref) pref = '';
    }
    render(pop, pref);
  }

  // 「配送料金をチェック」欄の中の表示を、選ばれた都道府県に合わせる
  function syncInline(source, pref) {
    var pops = document.querySelectorAll('[data-sr-pop][data-sr-inline]');
    Array.prototype.forEach.call(pops, function (pop) {
      if (pop === source) return;
      var select = pop.querySelector('[data-sr-pref]');
      var value = pref;
      if (select) {
        select.value = pref;
        value = select.value;
      }
      render(pop, value);
    });
  }

  function initInline(root) {
    var scope = root || document;
    var tabs = scope.querySelectorAll('[data-sr-tab]');
    Array.prototype.forEach.call(tabs, function (tab) {
      var block = tab.closest('.product-block');
      if (block) block.classList.add('product-block--tab');
    });
    var pops = scope.querySelectorAll('[data-sr-pop][data-sr-inline]');
    Array.prototype.forEach.call(pops, applySaved);
  }

  // tool-tip は開くたびに中身を複製し直すため、操作はすべて document で受ける
  document.addEventListener('change', function (e) {
    var select = e.target;
    if (!select.matches || !select.matches('[data-sr-pref]')) return;
    var pop = select.closest('[data-sr-pop]');
    if (!pop) return;
    savePref(select.value);
    render(pop, select.value);
    syncInline(pop, select.value);
  });

  // theme.js の tool-tip が中身を差し込んだ後に呼ばれる（同じ document リスナーで先に登録済み）
  document.addEventListener('tooltip:open', function (e) {
    var trigger = e.target && e.target.closest ? e.target.closest('.sr-tip__trigger') : null;
    if (!trigger) return;
    var pop = document.querySelector('tool-tip [data-tool-tip-content] [data-sr-pop]');
    if (pop) applySaved(pop);
    if (typeof window.gtag === 'function') {
      var rank = pop ? pop.getAttribute('data-sr-rank') : '';
      window.gtag('event', 'shipping_rank_tooltip_open', { shipping_rank: rank });
    }
  });

  function init() {
    placeTriggers(document);
    initInline(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // テーマエディタでセクションが再描画されたら置き直す
  document.addEventListener('shopify:section:load', function (e) {
    placeTriggers(e.target);
    initInline(e.target);
  });
})();